import React, { createContext, useContext, useState, useEffect } from 'react';

const ClubAuthContext = createContext();

export const useClubAuth = () => {
    return useContext(ClubAuthContext);
};

export const ClubAuthProvider = ({ children }) => {
    const [club, setClub] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Check for existing session
        const token = localStorage.getItem('clubToken');
        const clubId = localStorage.getItem('clubId');

        if (token && clubId) {
            setClub({ id: clubId, token });
        }
        setLoading(false);
    }, []);

    const login = (clubId, token) => {
        localStorage.setItem('clubToken', token);
        localStorage.setItem('clubId', clubId);
        setClub({ id: clubId, token });
    };

    const logout = () => {
        localStorage.removeItem('clubToken');
        localStorage.removeItem('clubId');
        setClub(null);
    };

    // Authenticated Fetch Helper
    const authFetch = async (url, options = {}) => {
        const token = localStorage.getItem('clubToken');

        const headers = {
            'Content-Type': 'application/json',
            ...options.headers,
            'Authorization': `Bearer ${token}`
        };

        const response = await fetch(url, {
            ...options,
            headers
        });

        if (response.status === 401) {
            logout(); // Auto logout on 401
            throw new Error('Session expired');
        }

        return response;
    };

    const value = {
        club,
        loading,
        login,
        logout,
        authFetch
    };

    return (
        <ClubAuthContext.Provider value={value}>
            {!loading && children}
        </ClubAuthContext.Provider>
    );
};
